export default __webpack_public_path__ + "images/0x553d3d295e0f695b9228246232edf400ed3560b5.png";